export default __webpack_public_path__ + "static/media/outs.117a62c4.svg";